<template>
  <footer class="backgroundfourth text-white pb-5 t1-footer-border t1-section-px">
    <div class="container-lg">


      <div class="d-flex justify-content-between flex-wrap pt-3 small text-muted">
        <div>&copy; {{ year }} {{ company.name }}. All rights reserved.</div>
        <div>{{ company.license }}</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Theme1Footer',
  props: {
    company: { type: Object },
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
